export function headerFunc() {
  $(window).scroll(function() {
    let scrollTop = $(this).scrollTop();

    if ( scrollTop > 140 ) {
      $('.l-header').addClass('is--scroll');
      $('body').addClass('is--scroll');
    } else {
      $('.l-header').removeClass('is--scroll');
      $('body').removeClass('is--scroll');
    }
  });

  $('.l-header__burger').click(function () {
    $(this).toggleClass('is--open');
    $('.l-header__bottom').toggleClass('is--open');
  });
}
